import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateQuestionRes;
export const addUpdateQuestionTodo = createAsyncThunk('addUpdateQuestion', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/add_update_question',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "question_id": data.question_id,
                "question": data.question,
                "remark": data.remark,
                "options": data.options,
                "correct_ans": data.right,
                "department_name": data.department,
                "status": data.status,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateQuestionRes = res.data
    } catch (error) {
        return addUpdateQuestionRes = error.response.data
    }
})